(() => {
  const roots = document.querySelectorAll("[data-product-save-stock-request-actions]");
  if (!roots.length) return;
  const post = async (path, body) => {
    const r = await fetch(`/apps/product-saves-stock-requests/${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    });
    let d = {};
    try {
      d = await r.json();
    } catch {}
    if (!r.ok || !d.ok) {
      const e = new Error(
        d.error || `The request could not be completed (HTTP ${r.status}).`,
      );
      e.code = d.code;
      throw e;
    }
    return d;
  };
  roots.forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    const data = JSON.parse(root.querySelector("[data-pg-data]").textContent);
    const save = root.querySelector("[data-pg-save]");
    const bis = root.querySelector("[data-pg-bis]");
    const special = root.querySelector("[data-pg-special]");
    const authPanel = root.querySelector('[data-pg-panel="auth"]');
    const bisPanel = root.querySelector('[data-pg-panel="bis"]');
    const specialPanel = root.querySelector('[data-pg-panel="special"]');
    const marketingPrompt = root.querySelector("[data-pg-marketing]");
    const marketingToggle = root.querySelector("[data-pg-marketing-toggle]");
    const variantInput =
      document.querySelector(
        `#product-form-${CSS.escape(data.sectionId)} .product-variant-id`,
      ) || document.querySelector(`form[action*="/cart/add"] [name="id"]`);
    let saved = data.saved;
    let marketingEnabled = Boolean(data.marketingEnabled);
    let pendingBisRequest = null;
    const bisVariants = new Set(data.bisVariantIds.map(String));
    let current = String(variantInput?.value || data.initialVariantId);
    const setStatus = (panel, text, error = false) => {
      const el = panel?.querySelector("[data-pg-status]");
      if (el) {
        el.textContent = text || "";
        el.classList.toggle("is-error", error);
      }
    };
    const iconState = () => {
      save.classList.toggle("is-active", saved);
      save.setAttribute("aria-pressed", String(saved));
      save.querySelector("[data-label]").textContent = saved
        ? "Saved for later"
        : "Save for later";
    };
    const selected = () =>
      data.variants.find((v) => String(v.id) === current) || data.variants[0];
    const storeOptions = (v) =>
      v.stores.filter(
        (s) =>
          ["newmarket", "barrie", "winnipeg"].some((n) =>
            s.name.toLowerCase().includes(n),
          ) &&
          !s.available,
      );
    const option = (kind, id, name, checked = false) =>
      `<label class="pg-feature-option"><input type="checkbox" data-kind="${kind}" data-location-id="${id || ""}" ${checked ? "checked" : ""}><span>${name}</span></label>`;
    const render = () => {
      const v = selected();
      if (!v) return;
      const stores = storeOptions(v);
      const isSpecial = data.specialOrder && v.tracked && stores.length > 0;
      const shipping = !v.available;
      bis.hidden =
        data.specialOrder || !v.tracked || (!shipping && !stores.length);
      special.hidden = !isSpecial;
      bis.classList.toggle("is-active", bisVariants.has(String(v.id)));
      bis.querySelector("[data-label]").textContent = bisVariants.has(
        String(v.id),
      )
        ? "Notification saved"
        : "Back in stock";
      bisPanel.querySelector("[data-submit]").textContent = bisVariants.has(
        String(v.id),
      )
        ? "Remove notification"
        : "Save notification";
      if (!bisPanel.hidden) {
        const box = bisPanel.querySelector("[data-options]");
        box.innerHTML =
          stores.map((s) => option("store", s.locationId, s.name)).join("") +
          (shipping ? option("shipping", "", "Shipping") : "");
        const alreadySaved = bisVariants.has(String(v.id));
        marketingPrompt.hidden = marketingEnabled || alreadySaved;
        marketingToggle.setAttribute(
          "aria-checked",
          String(marketingEnabled),
        );
      }
      if (!specialPanel.hidden) {
        specialPanel.querySelector("[data-options]").innerHTML = storeOptions(v)
          .map((s) => option("store", s.locationId, s.name))
          .join("");
        bindSingleChoice();
      }
    };
    const closeAll = () => {
      pendingBisRequest = null;
      authPanel.hidden = true;
      bisPanel.hidden = true;
      specialPanel.hidden = true;
    };
    const openAuth = (feature) => {
      const messages = {
        save: "Sign in or create an account to save products for later.",
        bis: "Sign in or create an account to receive back-in-stock notifications. Email marketing must also be enabled.",
        special:
          "Sign in or create an account to submit a special-order request.",
      };
      closeAll();
      authPanel.querySelector("[data-pg-auth-message]").textContent =
        messages[feature];
      authPanel.querySelector("[data-pg-auth-link]").href = data.loginUrl;
      authPanel.hidden = false;
    };
    const open = (panel) => {
      const was = panel.hidden;
      closeAll();
      panel.hidden = !was;
      setStatus(panel, "");
      render();
    };
    const bindSingleChoice = () => {
      specialPanel.querySelectorAll('input[type="checkbox"]').forEach(
        (input) =>
          (input.onchange = () => {
            const all = [
              ...specialPanel.querySelectorAll('input[type="checkbox"]'),
            ];
            if (input.checked)
              all.forEach((x) => {
                if (x !== input) x.disabled = true;
              });
            else all.forEach((x) => (x.disabled = false));
          }),
      );
    };
    const submitBisNotification = async (variantId, targets, button) => {
      button.disabled = true;
      setStatus(bisPanel, "Saving…");
      try {
        await post("back-in-stock", {
          variantId,
          action: "add",
          targets,
        });
        pendingBisRequest = null;
        bisVariants.add(String(variantId));
        setStatus(bisPanel, "Notification saved.");
        render();
        setTimeout(closeAll, 900);
      } catch (error) {
        if (error.code === "MARKETING_REQUIRED") {
          marketingEnabled = false;
          pendingBisRequest = { variantId: String(variantId), targets };
          marketingPrompt.hidden = false;
          marketingToggle.setAttribute("aria-checked", "false");
        }
        setStatus(bisPanel, error.message, true);
      } finally {
        button.disabled = false;
      }
    };
    root
      .querySelectorAll("[data-close]")
      .forEach((x) => x.addEventListener("click", closeAll));
    save.addEventListener("click", async () => {
      if (!data.loggedIn) {
        openAuth("save");
        return;
      }
      save.disabled = true;
      setStatus(null, "");
      try {
        const next = !saved;
        await post("save", {
          productId: data.productId,
          action: next ? "add" : "remove",
        });
        saved = next;
        iconState();
      } catch (e) {
        alert(e.message);
      } finally {
        save.disabled = false;
      }
    });
    bis.addEventListener("click", () => {
      if (!data.loggedIn) {
        openAuth("bis");
        return;
      }
      open(bisPanel);
    });
    special.addEventListener("click", () => {
      if (!data.loggedIn) {
        openAuth("special");
        return;
      }
      open(specialPanel);
    });
    marketingToggle.addEventListener("click", async () => {
      if (marketingEnabled) return;
      marketingToggle.disabled = true;
      setStatus(bisPanel, "Enabling email marketing…");
      try {
        const result = await post("email-marketing", { enabled: true });
        marketingEnabled = result.marketingEnabled === true;
        marketingToggle.setAttribute(
          "aria-checked",
          String(marketingEnabled),
        );
        marketingPrompt.hidden = marketingEnabled;
        setStatus(
          bisPanel,
          marketingEnabled
            ? "Email marketing enabled."
            : "Shopify did not enable email marketing. Please try again.",
          !marketingEnabled,
        );
        if (marketingEnabled && pendingBisRequest) {
          const pending = pendingBisRequest;
          pendingBisRequest = null;
          if (String(selected()?.id) === pending.variantId) {
            await submitBisNotification(
              pending.variantId,
              pending.targets,
              bisPanel.querySelector("[data-submit]"),
            );
          }
        }
      } catch (error) {
        setStatus(bisPanel, error.message, true);
      } finally {
        marketingToggle.disabled = false;
      }
    });
    bisPanel
      .querySelector("[data-submit]")
      .addEventListener("click", async (e) => {
        const v = selected();
        const button = e.currentTarget;
        if (bisVariants.has(String(v.id))) {
          button.disabled = true;
          try {
            await post("back-in-stock", { variantId: v.id, action: "remove" });
            bisVariants.delete(String(v.id));
            closeAll();
            render();
          } catch (err) {
            setStatus(bisPanel, err.message, true);
          } finally {
            button.disabled = false;
          }
          return;
        }
        const targets = [...bisPanel.querySelectorAll("input:checked")].map(
          (x) => ({
            kind: x.dataset.kind,
            locationId: x.dataset.locationId || null,
          }),
        );
        if (!targets.length) {
          setStatus(bisPanel, "Choose at least one option.", true);
          return;
        }
        if (!marketingEnabled) {
          pendingBisRequest = { variantId: String(v.id), targets };
          marketingPrompt.hidden = false;
          setStatus(
            bisPanel,
            "Turn on email marketing to save this notification.",
            true,
          );
          return;
        }
        pendingBisRequest = null;
        await submitBisNotification(v.id, targets, button);
      });
    specialPanel
      .querySelector("[data-submit]")
      .addEventListener("click", async (e) => {
        const v = selected();
        const choice = specialPanel.querySelector("input:checked");
        if (!choice) {
          setStatus(specialPanel, "Choose one store.", true);
          return;
        }
        const button = e.currentTarget;
        button.disabled = true;
        setStatus(specialPanel, "Sending request…");
        try {
          const d = await post("special-order", {
            variantId: v.id,
            locationId: choice.dataset.locationId,
          });
          setStatus(specialPanel, `Request saved for ${d.store}.`);
          setTimeout(closeAll, 1100);
        } catch (err) {
          setStatus(specialPanel, err.message, true);
        } finally {
          button.disabled = false;
        }
      });
    if (
      typeof subscribe === "function" &&
      window.PUB_SUB_EVENTS?.variantChange
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const id = event?.data?.variant?.id;
        if (id) {
          current = String(id);
          closeAll();
          render();
        }
      });
    }
    variantInput?.addEventListener("change", () => {
      current = String(variantInput.value);
      closeAll();
      render();
    });
    iconState();
    render();
  });
})();
